module.exports = __webpack_public_path__ + "static/img/smarttool.8be6ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smarttool.svg
// module id = Bxak
// module chunks = 1